var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 7.27271C8.49542 7.27271 7.27271 8.49542 7.27271 9.99998C7.27271 11.5045 8.49542 12.7273 9.99998 12.7273C11.5045 12.7273 12.7273 11.5045 12.7273 9.99998C12.7273 8.49542 11.5045 7.27271 9.99998 7.27271Z",
    fill: "#777E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.18182C5.45455 3.18182 1.57274 6.00907 0 10C1.57274 13.9909 5.45455 16.8182 10 16.8182C14.55 16.8182 18.4273 13.9909 20 10C18.4273 6.00907 14.55 3.18182 10 3.18182ZM10 14.5454C7.49093 14.5454 5.45455 12.5091 5.45455 9.99997C5.45455 7.49087 7.49093 5.45454 10 5.45454C12.5091 5.45454 14.5455 7.49092 14.5455 10C14.5455 12.5091 12.5091 14.5454 10 14.5454Z",
    fill: "#777E8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.b89a7f183896843983fe80700e82aeb0.svg";
export { ForwardRef as ReactComponent };